import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import styled, { css } from 'styled-components';

export const StyledCircleButton = styled.button<{
  disabled?: boolean;
  direction?: string;
}>`
  height: ${(props) => (props.direction === 'close' ? '40px' : '50px')};
  width: ${(props) => (props.direction === 'close' ? '40px' : '50px')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.atlas.semantic.color.outline.default
      : props.theme.atlas.semantic.color.action.primary.default};
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  border: ${(props) =>
    props.disabled
      ? 'none'
      : `1px solid ${props.theme.atlas.semantic.color.action.primary.default}`};

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }

  & > svg {
    font-size: 2.5rem;
  }

  @media (hover: hover) {
    &:hover {
      ${(props) =>
        props.disabled
          ? 'cursor: not-allowed;'
          : `color: ${props.theme.atlas.semantic.color.action.primary.onPrimary};
    background-color: ${props.theme.atlas.semantic.color.action.primary.hover};
    border: 1px solid ${props.theme.atlas.semantic.color.action.primary.hover};`}
    }
  }

  cursor: pointer;

  &:focus {
    outline: thin;
    color: ${({ theme }) =>
      theme.atlas.semantic.color.action.primary.onPrimary};
    ${(props) =>
      props.disabled
        ? 'cursor: not-allowed;'
        : `color: ${props.theme.atlas.semantic.color.action.primary.onPrimary};
    background-color: ${props.theme.atlas.semantic.color.action.primary.hover};
    border: 1px solid ${props.theme.atlas.semantic.color.action.primary.hover};`}
  }
`;

const arrowCSS = css`
  font-size: 50px;
  color: ${({ theme }) => theme.atlas.semantic.color.surface.default};
  position: relative;
  right: 0px;
  top: 0px;
`;

export const CircleButtonArrowLeft = styled(KeyboardArrowLeft)`
  ${arrowCSS}
`;

export const CircleButtonArrowRight = styled(KeyboardArrowRight)`
  ${arrowCSS}
`;

export const CircleButtonClose = styled.img`
  height: 16px;
  color: ${({ theme }) => theme.atlas.semantic.color.surface.default};
`;
